import { CaretDownOutlined, InfoCircleOutlined, LogoutOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { getFullVelocityUrl, getUserName } from '../../../Helper';
import { UserProfileDropdownAction } from '../../../model/CommonModel';
import { OptionsButtonBuilder } from '../../../model/DeviceAdminModel';
import { AboutModal, ButtonDropdown } from '../../common';

const createButtonOptions = (): OptionsButtonBuilder<number> => {
	return {
		labelOrIcon: `${getUserName()}`,
		options: [
			{
				id: 'userProfileDropdownAboutButton',
				label: _('About'),
				value: UserProfileDropdownAction.about,
				icon: <InfoCircleOutlined />,
			},
			{
				id: 'userProfileDropdownHelpButton',
				label: _('Help'),
				value: UserProfileDropdownAction.help,
				icon: <QuestionCircleOutlined />,
			},
			{
				id: 'userProfileDropdownSettingsButton',
				label: _('Settings'),
				value: UserProfileDropdownAction.settings,
				icon: <SettingOutlined data-leavetab={true} />,
				leaveTab: true,
				separator: true,
			},
			{
				id: 'userProfileDropdownLogoutButton',
				label: _('Logout'),
				value: UserProfileDropdownAction.logout,
				leaveTab: true,
				icon: <LogoutOutlined data-leavetab={true} />,
			},
		],
	};
};

const fullVelocityUrl: string = getFullVelocityUrl();

const UserProfileDropdown = () => {
	const [displayAboutModal, setDisplayAboutModal] = useState<boolean>(false);

	const handleActionScope = async (action: UserProfileDropdownAction) => {
		switch (action) {
			case UserProfileDropdownAction.about:
				setDisplayAboutModal(true);
				break;

			case UserProfileDropdownAction.help:
				window.open(`${fullVelocityUrl}Content/Files/Velocity_Web_Services_Client_User_Guide_v_3.8.5.597.pdf`);
				break;

			case UserProfileDropdownAction.settings:
				window.location.href = `${fullVelocityUrl}Configuration/ConfigurationManager`;
				break;

			case UserProfileDropdownAction.logout:
				window.location.href = `${fullVelocityUrl}/Account/LogOff`;
				break;
		}
	};

	const items: OptionsButtonBuilder<number> = createButtonOptions();

	return (
		<>
			<ButtonDropdown
				id={'UserProfileTableActionDropdown'}
				menuOptions={items.options}
				icon={<CaretDownOutlined />}
				labelIcon={items.labelOrIcon}
				onClickOption={handleActionScope}
			/>
			{displayAboutModal && <AboutModal hideModal={() => setDisplayAboutModal(false)} />}
		</>
	);
};

export { UserProfileDropdown };

